import { EnvironmentType, ExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
export function CheckIsDevelop() {
  const typeEnv = Number(process.env.VUE_APP_TYPE_ENV);
  if (!isNaN(typeEnv)) {
    return typeEnv <= EnvironmentType.SIT;
  }
  return false;
}
export function GetMessageExceptionCode(exception: any, text: any = "") {
  let message: any = "";
  switch (exception.code) {
    case ExceptionCode.CodeDuplicated:
      message = i18n.t("Exceptions_Notification.CodeDuplicated", { text: text });
      break;
    case ExceptionCode.CodeIsEmpty:
      message = i18n.t("Exceptions_Notification.CodeIsEmpty", { text: text });
      break;
    case ExceptionCode.IsHaveEmployee:
      message = i18n.t("Exceptions_Notification.IsHaveEmployee");
      break;
    case ExceptionCode.IsHaveSalaryEmployee:
      message = i18n.t("Exceptions_Notification.IsHaveSalaryEmployee");
      break;
    default:
      message = i18n.t("Something_Wrong", { errorMessage: exception.code });
      break;
  }
  return message;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}

export function GetUserIdFromCommentText(commentText: string) {
  if (commentText) {
    const userIds = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds) {
      const extractedUserIds = userIds.map((userId: any) => Number(userId.match(/\d+/)[0]));
      return extractedUserIds;
    }
  }
  return [];
}

export function GetCommentTextForDisplay(commentText: string, userIdListForMap: Map<number, any>) {
  let commentTextForDisplay = commentText;
  if (commentText) {
    const userIds: any = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds && userIds.length > 0) {
      for (const userId of userIds) {
        const extractedUserId = Number(userId.match(/\d+/)[0]);
        const selectedUser = userIdListForMap.get(extractedUserId);
        if (selectedUser) {
          const userNameBox = `<span style="color:#3297ff;font-family: 'Maibork-bold';">@${selectedUser.displayName}</span>`;
          commentTextForDisplay = commentTextForDisplay.replaceAll(userId, userNameBox);
        }
      }
    }
  }
  return commentTextForDisplay;
}
